import React, {Component} from 'react';
import {connect} from 'react-redux';
import {checkUserRole} from 'actions/AuthActions';

class EnsureAdmin extends Component {
  state = {
    checkingPremission: true
  }

  finishPresmissionChecking = () => {
    this.setState({
      checkingPremission: false
    })
  }

  componentDidMount() {
    this.props.dispatch(checkUserRole([0], this.finishPresmissionChecking));
  }

  render() {
    return (
      <div>
        {!this.state.checkingPremission && this.props.children}
      </div>
    );
  }
}

export default connect()(EnsureAdmin);



// WEBPACK FOOTER //
// ./src/containers/EnsureAdmin.js